module.exports = __webpack_public_path__ + "static/media/help-rule-5b.fd41c66d.gif";